<template>
  <v-app class="bg-content" :style="'background-color: '+aplicacao.store.home.back+'!important;'">
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line="snackbar.mode === 'multi-line'"
      :timeout="snackbar.timeout"
      :vertical="snackbar.mode === 'vertical'"
      top auto-height
    >{{snackbar.text}}
    </v-snackbar>
    <MenuLateral  v-bind:menulateral="conteudos.menulateral" v-bind:menuLateralShow="aplicacao.menuLateral" @fecha-menu-lateral="cliqueMenuLateral"></MenuLateral>
    <BarraDeFerramentas @clique-menu-lateral="cliqueMenuLateral" v-bind:menulateral="conteudos.menulateral" v-bind:qtdItensPedido="cart.length" v-on:abrir-dialog-pedido="cliqueModalPedido" v-bind:toolbar="aplicacao.store.toolbar"></BarraDeFerramentas>
    <v-content :class="aplicacao.store.home.class">
    <!-- INICIO DIALOGO PARA IFRAME -->
    <v-layout row justify-center>
      <v-dialog v-model="modalIframe.open" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark :color="aplicacao.store.pages.header.back">
            <v-btn icon dark @click="modalIframe.open = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-html="modalIframe.title"></v-toolbar-title>
          </v-toolbar>
          <iframe :src="modalIframe.url" style="
              width: 100%;
              height: 800px;
            "></iframe>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- FIM DIALOGO PARA IFRAME -->
      <v-layout row justify-center>
        <v-dialog v-model="modalsOpen.formapagamento" width="450">
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>Formas de Pagamento</v-card-title>
            <v-card-text v-if="aplicacao.store.formaspagamento">
              <ul>
                <li v-for="(forma, fi) in aplicacao.store.formaspagamento" v-html="forma"></li>
              </ul>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="modalsOpen.formapagamento = false">
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <FormAcessoDeUsuario v-if="negocio&&!negocio.usuario" v-bind:baseUrlApi="aplicacao.baseUrlApi" v-bind:dialog="aplicacao.modalAcessoDeUsario" @fechar-modal="cliqueModaAcessoDeUsuario" @logar-usuario="logarUsuario" @cadastrar-usuario="cadastrarUsuario"></FormAcessoDeUsuario>
      <ModalSobre v-bind:dialog="aplicacao.modalSobre" @click-dialog="aplicacao.modalSobre=!aplicacao.modalSobre" v-bind:pages="aplicacao.store.pages" v-bind:content="aplicacao.store.sobre.content"></ModalSobre>
      <ModalUser v-if="negocio!=null && negocio.usuario!=false && aplicacao.modalUsuario!=null" v-bind:conteudo="conteudos.modalUser" v-bind:baseUrlApi="aplicacao.baseUrlApi" v-bind:baseUrlPagar="aplicacao.baseUrlPagar" v-bind:usuario="negocio.usuario" v-bind:dialog="aplicacao.modalUsuario" v-bind:pages="aplicacao.store.pages" v-bind:info="aplicacao.store.info"
        @fechar-modal="cliqueModalUser" @deslogar-usuario="deslogarUsuario" @ver-pedido="verPedido" @fechar-pedido="fecharPedido" @click-em-tab="alterarSessaoEmModalUser" @dados-pessoais-atualizados="dadosPessoaisAtualizados" @cancelando-pedido="resposta_cancelandoPedido" @snackbar-alert="snackbarAlert" @abri-modal-iframe="openModalIframe" @erro-loginno="erroLoginno"
        ></ModalUser>
      <ModalCadEndereco ref="ModalCadEndereco" @cadastrar-novo-endereco="cadastrarNovoEndereco" v-bind:baseUrlApi="aplicacao.baseUrlApi"></ModalCadEndereco>
      <ModalPedido ref="ModalPedido" v-if="negocio!=null" v-bind:dialog="aplicacao.modalPedido" v-bind:cart="cart" v-bind:totalPedido="totalPedido" v-bind:usuario="negocio.usuario" v-on:fechar-modal="cliqueModalPedido" v-bind:pages="aplicacao.store.pages" @clique-botao-remove="removerItemDoCarinho" @clique-botao-add="inserirMaisUmNoCarrinho" @acesso-de-usuario="cliqueModaAcessoDeUsuario" @registrar-pedido="registrarPedido" v-bind:baseUrlApi="aplicacao.baseUrlApi" @open-cad-endereco="openCadEndereco()" @snackbar-alert="snackbarAlert" @erro-loginno="erroLoginno"></ModalPedido>
      <ListCardapioExpansivo ref="ModalProdutoAdicionado" v-on:abrir-dialog-pedido="cliqueModalPedido" v-bind:baseUrlApi="aplicacao.baseUrlApi" v-bind:toolbar="aplicacao.store.toolbar"></ListCardapioExpansivo>
      <ModalProduto v-if="produtoAberto!=null" v-bind:produto="negocio.categorias[produtoAberto.categoria].produtos[produtoAberto.produto]" v-bind:estoque="negocio.estoque" @clique-no-botao-cancelar="produtoAberto=null" @clique-no-botao-inserir="inserirNoPedido" v-bind:baseUrlApi="aplicacao.baseUrlApi"></ModalProduto>
      <div :class="aplicacao.store.home.classLogo">
        <v-img :src="aplicacao.store.home.logo" style="max-width: 150px;" class="mx-auto logo"></v-img>
      </div>
      <v-alert v-if="negocio && negocio.n_doc.delivery && negocio.n_doc.delivery.situacao && negocio.n_doc.delivery.situacao=='false'" :value="true" color="error" icon="warning" outline>
        {{negocio.n_doc.delivery.avisoFechado}}
      </v-alert>
      <transition name="fade" mode="out-in">
        <div v-if="!abriCardapio" class="mx-2 text-xs-center">
          <template v-if="aplicacao.store.home.banner && aplicacao.store.home.banner.length>0">
            <div v-for="banner in aplicacao.store.home.banner">
              <span v-if="banner.type=='text'" v-html="banner.content" :style="'color: '+aplicacao.store.home.text+'!important'"></span>
              <img v-else-if="banner.type=='img'" :src="banner.content" style="max-height:300px;max-width:100%;">
              <a v-else-if="banner.type=='link' && banner.content.length>0" :href="banner.href" :target="banner.target">
                <template v-for="contetlink in banner.content">
                  <span v-if="contetlink.type=='text'" v-html="contetlink.content"></span>
                  <img v-else-if="contetlink.type=='img'" width="100%" :src="contetlink.content">
                </template>
              </a>
            </div>
          </template>
          <template v-if="negocio && negocio.n_doc.delivery && negocio.n_doc.delivery.situacao && negocio.n_doc.delivery.situacao=='false'">
            <v-btn v-if="aplicacao.store.home.button && aplicacao.store.home.button.comprar.color" block :color="aplicacao.store.home.button.comprar.color" :class="aplicacao.store.home.button.comprar.class" @click="abriCardapio=true">Ver produtos</v-btn>
            <v-btn v-else block color="success" @click="abriCardapio=true">Ver produtos</v-btn>
          </template>
          <template v-else>
            <v-btn v-if="aplicacao.store.home.button && aplicacao.store.home.button.comprar.color" block :color="aplicacao.store.home.button.comprar.color" :class="aplicacao.store.home.button.comprar.class" @click="abriCardapio=true">Compre aqui</v-btn>
            <v-btn v-else block color="success" @click="abriCardapio=true">Compre aqui</v-btn>
          </template>
        </div>
        <div v-else-if="negocio">
          <v-layout>
            <v-flex v-if="filtro.content!=''" shrink>
              <v-btn flat icon color="secondary" @click="filtro.content=''">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
            <v-flex>
              <v-text-field v-if="negocio.n_id && aplicacao.store.inputserach" label="Pesquisar" v-model="filtro.content" class="mb-0"></v-text-field>
            </v-flex>
          </v-layout>
          <Cardapio v-bind:cardapio="negocio.categorias" v-bind:filtro="filtro" @clique-no-produto="setProdutoAberto" @clique-no-botao-inserir="inserirNoPedido"></Cardapio>
        </div>
        <div class="text-xs-center" v-else>
          <v-progress-circular
            indeterminate
            color="secondary"
          ></v-progress-circular>
        </div>
        </transition>
        <!--
      //##################################################
			//####  RECEM DESABILITADA LISTAGEM DE BAIRROS  ####
			//##################################################
			
        <transition name="fade" mode="out-in">
            <div v-if="!abriBairrosAtendidos||!negocio" class="text-xs-center mx-2">
              <v-btn block color="secondary" @click="abriBairrosAtendidos=true">Bairros Atendidos</v-btn>
            </div>
            <div v-else class="mx-2 text-xs-center">
              <div class="mx-2 text-xs-center" v-if="negocio.bairrosatendidos">
                  <div class="subreading my-1">Bairros Atendidos:</div>
                  <v-data-table :headers="[{text:'Bairro',sortable: false,value: 'bairro'},{text:'Taxa',sortable: false,value: 'taxa'},{text:'Dias de entrega',sortable: false,value: 'dias'}]" :items="negocio.bairrosatendidos" class="elevation-1 mb-4">
                    <template v-slot:items="props">
                      <template v-if="props.item.colspan=='2'">
                        <td colspan="3">{{ props.item.nome }}</td>
                      </template>
                      <template v-else>
                        <td>{{ props.item.nome }}</td>
                        <td class="text-xs-right">R$ {{ parseFloat(props.item.taxa).toFixed(2).replace(".",",") }}</td>
                        <td>{{ props.item.dias }}</td>
                      </template>
                    </template>
                  </v-data-table>
              </div>
            </div>
        </transition>
        -->
        <transition name="fade" mode="out-in">
            <div v-if="!atendimento.open" class="text-xs-center mx-2">
              <v-btn block color="secondary" @click="openBairrosAtendidos()">Bairros Atendidos</v-btn>
            </div>
            <div v-else class="mx-2 text-xs-center white">
              <div class="mx-2 text-xs-left" v-if="atendimento.bairros || true">
                  <v-layout wrapp>
                    <v-flex class="subreading my-1 text-xs-center">Bairros Atendidos:</v-flex>
                    <v-flex shrink>
                      <v-btn icon flat color="error" small outline @click="atendimento.open=false">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <div class="text-xs-center" v-if="atendimento.loader">
                    <v-progress-circular indeterminate color="secondary"></v-progress-circular>
                  </div>
                  <template v-if="atendimento.bairros">
                    <div v-for="(bairro,bIndex) in atendimento.bairros">
                      <hr>
                      <div v-html="bairro.nome"></div>
                      <span class="grey--text" v-html="'Taxa: R$ '+parseFloat(bairro.doc.taxa.replace(',','.')).toFixed(2).replace('.',',')"></span>
                      <span class="grey--text"> - Dias: 
                        <span v-for="(dia,dIndex) in bairro.doc.dias">
                          <span v-if="dIndex>0" v-html="', '"></span>
                          <span v-html="atendimento.label[dia]"></span>
                        </span>
                      </span>
                    </div>
                    <template v-if="atendimento.paginas>1">
                      <div class="text-xs-center">
                        <v-pagination
                          v-model="atendimento.pagina"
                          :length="atendimento.paginas"
                          :total-visible="7"
                          @input="listBairrosAtendidos()"
                        ></v-pagination>
                      </div>
                    </template>
                  </template>
              </div>
            </div>
          <!-- </template> -->
        </transition>
        <div class="mx-2 text-xs-center">
          <v-btn color="secondary" @click="cliqueMenuLateral" block outline>Contatos</v-btn>
          <v-btn color="secondary" block outline @click="modalsOpen.formapagamento = true" v-if="aplicacao.store.formaspagamento && aplicacao.store.formaspagamento.length>0">Formas de Pagamento</v-btn>
        </div>
    </v-content>
    <MenuInferior v-bind:tamanhoSobre="aplicacao.store.sobre.content.length" v-on:alternar-content="alternarContent" v-on:abrir-dialog-pedido="cliqueModalPedido" v-bind:qtdItensPedido="cart.length" @abrir-dialog-user="cliqueModalUser" @click-dialog-sobre="aplicacao.modalSobre=!aplicacao.modalSobre" v-bind:bottombar="aplicacao.store.bottombar" @clique-em-home="abriCardapio=false,abriBairrosAtendidos=false"></MenuInferior>
  </v-app>
</template>

<script>
import jquery from 'jquery';
import BarraDeFerramentas from "./components/BarraDeFerramentas";
import MenuLateral from './components/MenuLateral';
import MenuInferior from './components/MenuInferior';
import ModalPedido from './components/ModalPedido';
import Cardapio from './components/ListCardapio';
import ModalProduto from './components/ModalProduto';
import ModalUser from './components/ModalUser';
import FormAcessoDeUsuario from './components/FormAcessoDeUsuario';
import ModalSobre from './components/ModalSobre';
import ModalCadEndereco from './components/ModalCadEndereco';
import ListCardapioExpansivo from './components/ListCardapioExpansivo';

export default {
  name: 'App',
  components: {
    BarraDeFerramentas,
    MenuLateral,
    MenuInferior,
    ModalPedido,
    Cardapio,
    ModalProduto,
    ModalUser,
    FormAcessoDeUsuario,
    ModalSobre,
    ModalCadEndereco,
    ListCardapioExpansivo
  },
   data() {
    return {
      aplicacao:{
        modalSobre: null,
        menuLateral: null,
        modalPedido: null,
        modalUsuario: null,
        modalAcessoDeUsario: null,
        content: "home",
        baseUrlApi: config.baseUrlApi+store.info.url+"/",
        baseUrlPagar: config.baseUrlPagar+store.info.url+"/",
        fb_track: fb_track,
        g_tag: g_tag,
        cache:[],
        store: store
      },
      modalIframe: {open: null,title:"VIEW",url:"", style:""},
      conteudos: {
        modalUser: {
          dadosPessoais: null,
          pedidos: null,
          pedidoAberto: null,
          sessao: -1,
          get: {pessoais:0,pedidos:0}
        },
        menulateral: []
      },
      cart: [],
      negocio: null,
      atendimento: {
        open: null,
        bairros: null,
        loader: false,
        paginas: 0,
        pagina: 1,
        label: ['nenhum','Dom','Seg','Ter','Qua','Qui','Sex','Sab']
      },
      produtoAberto: null,
      abriCardapio: false,
      abriBairrosAtendidos: false,

      usuario: null,
      snackbar:{
          show: false,
          color: '',
          mode: '',
          timeout: 2000,
          text: 'Hello, I\'m a snackbar'
      },
      filtro:{
        content: ''
      },
      modalsOpen:{formapagamento: false}
    }
  },
  methods:{
    listBairrosAtendidos(){
      this.openBairrosAtendidos(this.atendimento.pagina);
    },
    openBairrosAtendidos(page = 1){
      this.atendimento.open=true;
      this.atendimento.loader = true;
      jquery.get(this.aplicacao.baseUrlApi+'public_negocios/getAtendimento/'+page)
        .then(response => (
          this.atendimento.bairros = response.dados.bairros,
          this.atendimento.paginas = response.dados.paginas,
          this.atendimento.loader = false
        ));
    },
    cliqueMenuLateral(){
      this.aplicacao.menuLateral = !this.aplicacao.menuLateral;
    },
    cliqueModalPedido(){
      this.aplicacao.modalPedido = !this.aplicacao.modalPedido;
    },
    cliqueModaAcessoDeUsuario(){
      this.aplicacao.modalAcessoDeUsario = !this.aplicacao.modalAcessoDeUsario;
    },
    cliqueModalUser(valor = null){
      if(valor=='false'){
        this.aplicacao.modalUsuario = false;
        return;
      }
      if(!this.negocio.usuario){
        this.cliqueModaAcessoDeUsuario();
      }else{
        this.aplicacao.modalUsuario = !this.aplicacao.modalUsuario;
      }
    },
    alternarContent(tab) {
      this.aplicacao.content = tab;
    },
    setProdutoAberto(index,catIndex){
      this.produtoAberto = {produto: index,categoria: catIndex};
    },
    getQuantidadeNoPedido(obj){
      //var i;
      let qtd=0;
      for(let i=0;i<this.cart.length;i++){
        if(parseInt(this.cart[i].id)==parseInt(obj.id)){
          if(!obj.variacao || obj.variacao==false || obj.variacao=='false' || (obj.variacao.estoquepeloproduto && obj.variacao.estoquepeloproduto==true)){
            qtd+= this.cart[i].qtd;
          }else{
            if(JSON.stringify(this.cart[i].variacao.ref) == JSON.stringify(obj.variacao.ref)){
              qtd+= this.cart[i].qtd;
            }
          }
        }
        //Verificar nos opcionais, se tem opcional com produto vinculado
        if(this.cart[i].opcionais){
          for(let j=0;j<this.cart[i].opcionais.length;j++){
            if(this.cart[i].opcionais[j].produto && this.cart[i].opcionais[j].produto.id && this.negocio.estoque[this.cart[i].opcionais[j].produto.id]){
              if(obj.id==this.cart[i].opcionais[j].produto.id){
                qtd+=this.cart[i].opcionais[j].produto.qtd*this.cart[i].opcionais[j].qtd*this.cart[i].qtd;
                
              }
            }
          }
        }
      }
      return qtd;
    },
    getEstoqueDoProduto(obj){
      //Aqui é o formato novo, tendo uma variável estoque, cotendo o estoque de todos os produtos existentes no cardápio
      if(this.negocio.estoque[obj.id]){
        if(!obj.variacao || obj.variacao==false || obj.variacao=='false' || (obj.variacao.estoquepeloproduto && obj.variacao.estoquepeloproduto==true)){
          //Quando não for variável ou quando for variável e o estoque for pelo produto, já retorna a quantidade
          return this.negocio.estoque[obj.id];
        }
        //Quando for variável
        let v,va,vaLocalizada;
              for(v=0;v<this.negocio.estoque[obj.id].length;v++){
                vaLocalizada=true;
                for(va=0;va<this.negocio.estoque[obj.id][v].var.length;va++){
                  if(this.negocio.estoque[obj.id][v].var[va]!=obj.variacao.ref[va]){
                    vaLocalizada = false;
                  }
                }
                if(vaLocalizada==true){
                  return this.negocio.estoque[obj.id][v].estoque;
                }
              }
        return;
      }
      return 0;
      /*
      //Abaixo está a verificação antiga
      //Atualizado dia XX/XX/2020
      //Se não tiver impactos, pode apagar daqui para baixo
      //Verificando o estoque informado na lista de produtos dentro das categorias
      for(j=0;j<this.negocio.categorias.length;j++){
        for(i=0;i<this.negocio.categorias[j].produtos.length;i++){
          if(obj.id==this.negocio.categorias[j].produtos[i].id){
            if(!this.negocio.categorias[j].produtos[i].doc.variacao || this.negocio.categorias[j].produtos[i].doc.variacao==false || this.negocio.categorias[j].produtos[i].doc.variacao=='false' || (this.negocio.categorias[j].produtos[i].doc.variacao.estoquepeloproduto && this.negocio.categorias[j].produtos[i].doc.variacao.estoquepeloproduto==true)){
              return this.negocio.categorias[j].produtos[i].estoque;
            }else{
              for(v=0;v<this.negocio.categorias[j].produtos[i].estoque.length;v++){
                vaLocalizada=true;
                for(va=0;va<this.negocio.categorias[j].produtos[i].estoque[v].var.length;va++){
                  if(this.negocio.categorias[j].produtos[i].estoque[v].var[va]!=obj.variacao.ref[va]){
                    vaLocalizada = false;
                  }
                }
                if(vaLocalizada==true){
                  return this.negocio.categorias[j].produtos[i].estoque[v].estoque;
                }
              }
            }
          }
        }
      }
      return 0;
      */
    },
    resetarCamposEmProdutoAberto(){
      //console.log('abriu aqui');
      //console.log(this.produtoAberto);
      //console.log(this.negocio.categorias[this.produtoAberto.categoria].produtos[this.produtoAberto.produto].doc.adicionais);

      for(let i=0;i<this.negocio.categorias[this.produtoAberto.categoria].produtos[this.produtoAberto.produto].doc.adicionais.length;i++){
        for(let j=0;j<this.negocio.categorias[this.produtoAberto.categoria].produtos[this.produtoAberto.produto].doc.adicionais[i].itens.length;j++){
          if(this.negocio.categorias[this.produtoAberto.categoria].produtos[this.produtoAberto.produto].doc.adicionais[i].itens[j].qtd && this.negocio.categorias[this.produtoAberto.categoria].produtos[this.produtoAberto.produto].doc.adicionais[i].itens[j].qtd>0){
            //console.log(this.negocio.categorias[this.produtoAberto.categoria].produtos[this.produtoAberto.produto].doc.adicionais[i].itens[j]);
            this.negocio.categorias[this.produtoAberto.categoria].produtos[this.produtoAberto.produto].doc.adicionais[i].itens[j].qtd = 0;
            //console.log(this.negocio.categorias[this.produtoAberto.categoria].produtos[this.produtoAberto.produto].doc.adicionais[i].itens[j].qtd);
          }
          //Se não, irá verificar qual o modal correspondente e irá limpar os outros campos
        }
      }
    },
    inserirNoPedido(obj){
      if(parseInt(obj.qtd)<=0){
        this.snackbarAlert("A quantidade de itens adicionados precisa ser maior ou igual a 1.","error")
        return;
      }
      if(obj.variacao){
        for(let i=0;i<obj.variacao.value.length;i++){
          if(obj.variacao.value[i]==""){
            this.snackbarAlert("Campos obrigatórios não selecionados.","error")
            return;
          }
        }
      }
      if(this.negocio.n_doc.delivery && this.negocio.n_doc.delivery.situacao && this.negocio.n_doc.delivery.situacao=='false'){
        this.snackbarAlert(this.negocio.n_doc.delivery.avisoFechado,"error");
        return;
      }
      if((this.getQuantidadeNoPedido(obj)+obj.qtd)>this.getEstoqueDoProduto(obj)){
        this.snackbarAlert("Quantidade informada não disponível em estoque","error");
        return;
      }
      if(!this.verificarDisponibilidadeDeOpcionais(obj)){
        return;
      }
      //return;
      this.cart.push(obj);
      if(this.produtoAberto){
        this.resetarCamposEmProdutoAberto();
      }
      this.produtoAberto = null;
      this.$refs.ModalProdutoAdicionado.openDialog();
      //this.$refs.ModalProdutoAdicionado.dialog = true;
      //this.aplicacao.modalPedido = true;
      this.snackbarAlert("Produto inserido no carrinho","success");
      if(this.aplicacao.fb_track && this.aplicacao.fb_track["fb_track_addcart"]){
        fbq('track', this.aplicacao.fb_track["fb_track_addcart"]);
      }
      if(this.aplicacao.g_tag && this.aplicacao.g_tag["g_sendto"] && this.aplicacao.g_tag["g_tag_addcart"]){
        gtag('event', this.aplicacao.fb_track["g_tag_addcart"], {'send_to': this.aplicacao.g_tag["g_sendto"]});
      }
    },
    inserirMaisUmNoCarrinho(i){
      if(this.negocio.n_doc.delivery && this.negocio.n_doc.delivery.situacao && this.negocio.n_doc.delivery.situacao=='false'){
        this.snackbarAlert(this.negocio.n_doc.delivery.avisoFechado,"error");
        return;
      }
      if((this.getQuantidadeNoPedido(this.cart[i])+1)>this.getEstoqueDoProduto(this.cart[i])){
        this.snackbarAlert("Máximo disponível em estoque","error")
        return;
      }
      if(!this.verificarDisponibilidadeDeOpcionais(this.cart[i])){
        return;
      }
      this.cart[i].qtd += 1;
    },
    verificarDisponibilidadeDeOpcionais(obj){
      if(obj.opcionais){
        for(let i=0;i<obj.opcionais.length;i++){
          if(obj.opcionais[i].produto && obj.opcionais[i].produto.id && parseInt(obj.opcionais[i].produto.id)>0){
            if(this.getQuantidadeNoPedido(obj.opcionais[i].produto)+(obj.qtd*obj.opcionais[i].produto.qtd*obj.opcionais[i].qtd)>this.getEstoqueDoProduto(obj.opcionais[i].produto)){
              this.snackbarAlert("O produto "+obj.opcionais[i].nome+" possui apenas "+this.getEstoqueDoProduto(obj.opcionais[i].produto)+" unidades em estoque.","error");
              return;
            }
          }
        }
      }
      return true;
    },
    removerItemDoCarinho(i){
      if(this.cart[i].qtd>1){
        this.cart[i].qtd -= 1;
      }else{
        this.cart.splice(i,1);
      }
      this.snackbarAlert("Produto removido do carrinho","warning");
    },
    cadastrarUsuario(dados){
      jquery.post(this.aplicacao.baseUrlApi+'cadastrarNovoUsuario',dados).then(response =>(this.resposta_cadastrarUsuario(response)));
    },
    resposta_cadastrarUsuario(response){
        if(response.situacao==true){
          this.negocio.usuario=response.user
          this.cliqueModaAcessoDeUsuario();
          this.snackbarAlert(response.mensagem,"success");
        }else{
          this.snackbarAlert(response.mensagem,"error");
        }
    },
    logarUsuario(dados){
      jquery.post(this.aplicacao.baseUrlApi+'loginDeUsuario',dados).then(response =>(this.tentativaDeLogin(response)));
    },
    tentativaDeLogin(dados){
      if(dados.situacao==true){
        this.negocio.usuario=dados.user
        //this.cliqueModaAcessoDeUsuario();
        this.aplicacao.modalAcessoDeUsario = false;
        if(!this.aplicacao.modalPedido){
          this.cliqueModalUser();
        }else{
          this.$refs.ModalPedido.finalizarPedido();
        }
        this.snackbarAlert(dados.mensagem,"success");
      }else{
        //alert(dados.mensagem);
        this.snackbarAlert(dados.mensagem,"error");
      }
    },
    deslogarUsuario(){
      jquery.post(this.aplicacao.baseUrlApi+'logout').then(response =>(this.negocio.usuario=null));
      if(this.aplicacao.modalUsuario){
        this.cliqueModalUser();
      }
    },
    erroLoginno(){
      //alert('tratando erro');
      this.cliqueModaAcessoDeUsuario();
      this.$refs.ModalPedido.registrando = null;
      this.negocio.usuario=null;
    },
    /*
    usuarioStatus(){
      //jquery.post(this.aplicacao.baseUrlApi+'public_negocios/usuarioStatus').then(response =>());
    },
    */
    registrarPedido(dados){
      jquery.post(this.aplicacao.baseUrlApi+'pedidos/registrarNovo',{
          pedido: JSON.stringify({
                                  entrega: dados.entrega,
                                  itens: this.cart,
                                  opcoesDeEntrega: dados.opcoesDeEntrega,
                                  opcoesDeRetirada: dados.opcoesDeRetirada,
                                  loja: config.loja_id
                                }),
          cupom: dados.cupom,
          obs: dados.observacoes
        }).then(response =>(this.repostaDeRegistroDePedido(response)));
    },
    repostaDeRegistroDePedido(data){
      if(data.situacao==true){
        this.cart = [];
        this.cliqueModalPedido();
        //Mensagem dizendo que pedido foi cadastrado ou não
        this.conteudos.modalUser.pedidos = null;
        this.conteudos.modalUser.pedidoAberto = data.dados;
        this.alterarSessaoEmModalUser(0);
        this.cliqueModalUser();
        this.$refs.ModalPedido.registrando = null
        this.snackbarAlert(data.mensagem,"success");
        if(this.aplicacao.fb_track && this.aplicacao.fb_track["fb_track_register"]){
          fbq('track', this.aplicacao.fb_track["fb_track_register"]);
        }
        if(this.aplicacao.g_tag && this.aplicacao.g_tag["g_sendto"] && this.aplicacao.g_tag["g_tag_register"]){
          gtag('event', this.aplicacao.fb_track["g_tag_register"], {'send_to': this.aplicacao.g_tag["g_sendto"]});
        }
      }else{
        if(data.erro && data.erro=='loginno'){
          this.erroLoginno();
          return;
        }
        this.$refs.ModalPedido.registro_erro.msg = data.mensagem;
        this.snackbarAlert("Erro ao cadastrar...","error");
      }
    },
    resposta_cancelandoPedido(status,data){
      if(status){
        this.conteudos.modalUser.pedidoAberto.situacao = 0;
        this.conteudos.modalUser.pedidos=data.dados;
        //this.alterarSessaoEmModalUser(0);
        this.snackbarAlert(data.mensagem,"success");
      }else{
        this.snackbarAlert("Não foi possível cancelar o pedido","error");
      }
    },
    fecharPedido(){
      this.conteudos.modalUser.pedidoAberto=null;
    },
    verPedido(id){
      jquery.get(this.aplicacao.baseUrlApi+'pedidos/getPedido/'+id).then(response => (this.resposta_verPedido(response)));
    },
    resposta_verPedido(response){
      if(!response.situacao && response.erro && response.erro=='loginno'){
        this.erroLoginno();
        return;
      }
      this.conteudos.modalUser.pedidoAberto=response.dados;
    },
    alterarSessaoEmModalUser(n){
      var d = new Date();
      if(n==0){
        if(!this.conteudos.modalUser.pedidos || (this.conteudos.modalUser.get.pedidos+60)<parseInt((d.getTime()/1000))){
          jquery.get(this.aplicacao.baseUrlApi+'pedidos/getTodosPedidos').then(response => (this.resposta_alterarSessaoEmModalUser_Pedidos(response)));
          this.conteudos.modalUser.get.pedidos = parseInt((d.getTime()/1000));
        }
      }else if(n==1){
        if(!this.conteudos.modalUser.dadosPessoais){
          jquery.get(this.aplicacao.baseUrlApi+'cadastroDeUsuario/getDadosPessoais').then(response => (this.resposta_alterarSessaoEmModalUser_User(response)));
          this.conteudos.modalUser.get.pessoais = parseInt((d.getTime()/1000));
        }
      }
      this.conteudos.modalUser.sessao = n;
    },
    resposta_alterarSessaoEmModalUser_Pedidos(response){
      if(!response.situacao && response.erro && response.erro=='loginno'){
        //
        this.erroLoginno();
        return;
      }
      this.conteudos.modalUser.pedidos=response.dados;
    },
    resposta_alterarSessaoEmModalUser_User(response){
      if(!response.situacao && response.erro && response.erro=='loginno'){
        //
        this.erroLoginno();
        return;
      }
      this.conteudos.modalUser.dadosPessoais=response.dados;
    },
    dadosPessoaisAtualizados(response){
      this.conteudos.modalUser.dadosPessoais = response.dados;
      this.snackbarAlert(response.mensagem,'primary');
    },
    openCadEndereco(){
      this.$refs.ModalCadEndereco.loader.bairrosatendidos = true;
      this.$refs.ModalCadEndereco.dialog = true,
      jquery.post(this.aplicacao.baseUrlApi+'public_negocios/getBairrosAtendidos/forSelect')
      .then(response =>(
        this.$refs.ModalCadEndereco.enderecos.form.novo.bairros=response.dados,
        this.$refs.ModalCadEndereco.loader.bairrosatendidos = false
        ));
    },
    cadastrarNovoEndereco(endereco,origem){
      if(endereco.form.novo.endereco==""){
        this.snackbarAlert("O campo Endereço é obrigatório.","error");
        return;
      }
      if(endereco.form.novo.numero=="" && endereco.form.novo.complemento==""){
        this.snackbarAlert("Você precisa informar, obrigatoriamente, o número ou o complemento.","error");
        return;
      }
      var dadosPost;
      dadosPost = {
        bairronovo: endereco.form.novo.bairronovo,
        bairro: endereco.form.novo.bairro,
        cep: endereco.form.novo.cep,
        endereco: endereco.form.novo.endereco,
        numero: endereco.form.novo.numero,
        complemento: endereco.form.novo.complemento
      };
      jquery.post(this.aplicacao.baseUrlApi+'cadastroDeUsuario/cadastroDeEndereco/cadastrar',dadosPost)
        .then(response =>(this.respostaCadEndereco(response,origem)));
    },
    respostaCadEndereco(response,origem){
      if(response.situacao==true){
        this.dadosPessoaisAtualizados(response);
        this.$refs.ModalCadEndereco.enderecos.form.novo.bairro = null;
        this.$refs.ModalCadEndereco.enderecos.form.novo.endereco = "";
        this.$refs.ModalCadEndereco.enderecos.form.novo.open = false;
        this.$refs.ModalCadEndereco.dialog = false;
        if(origem=='finalizandoPedido'){
          this.$refs.ModalPedido.finalizarPedido();
        }
      }else{
        if(response.erro && response.erro=='loginno'){
          this.$refs.ModalCadEndereco.enderecos.form.novo.open = false;
          this.$refs.ModalCadEndereco.dialog = false;
          this.erroLoginno();
          return;
        }
        this.snackbarAlert(response.mensagem,"error");
      }
    },
    snackbarAlert(text,color){
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    openModalIframe(url,title){
      this.modalIframe.url = url;
      this.modalIframe.title = title;
      this.modalIframe.open = true;
    }
  },
  computed:{
    totalPedido(){
      var i;
      var total = 0;
      var itens = 0;
      if(this.cart.length>0){
        for(i=0;i<this.cart.length;i++){
          total += this.cart[i].qtd * this.cart[i].subtotal
          itens += this.cart[i].qtd;
        }
        return {total: total,itens: itens}
      }else{
        return {total: 0,itens: 0}
      }
    },
    produtoNoPedido(){
      var i;
      if(this.cart.length>0){
        for(i=0;i<this.cart.length;i++){
          if(this.cart[i].id == this.negocio.produtos[this.produtoAberto].id){
            return {
              resposta: true,
              qtd: this.cart[i].qtd,
              index: i
            }
          }
        }
      } 
      return {resposta: false}
    }
  },
  mounted () {
    jquery.get(this.aplicacao.baseUrlApi+'public_negocios').then(response => (this.negocio = response.dados));
    if(store && store.links && store.links.length>0){
      this.conteudos.menulateral = store.links;
    }
  }
}
</script>
<style>
  .bg-content{
    /*
    background-color: #1d1d1b!important;
    background-color: #1d1d1b!important;
    background-color: #82c14e!important;

    Ferreira
      Menu inferior: #dcdcdc
      Barra de ferramentas: #ffffff
      Modals: #000000
      get('./ferreira.json')
    */
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to,.fade-leave-active /* .fade-leave-active em versões anteriores a 2.1.8 */ {
    opacity: 0;
  }
  .logo200 .logo{
    width: 100%;
    max-width: 200px!important;
  }
  .logo250 .logo{
    max-width: 250px!important;
    width: 100%;
  }
  .logo300 .logo{
    max-width: 300px!important;
    width: 100%;
  }
  .logoRounded .logo{
    border-radius: 50%; 
    -webkit-radius:50%;
    -moz-radius:50%;
  }
  .text-decoration-line-through{
    text-decoration: line-through;
  }
</style>
